import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL;

const PAGES = [
  {
    path: '/programs',
    title: 'Programs',
    description: 'Create and manage insertion orders. Import directly from PDF or build manually.',
    color: '#e67e22',
    icon: '📋',
  },
  {
    path: '/components',
    title: 'Components',
    description: 'View and manage individual components across all programs.',
    color: '#9b59b6',
    icon: '🔧',
  },
  {
    path: '/goals',
    title: 'Goals',
    description: 'Track delivery goals and supplier assignments for each component.',
    color: '#27ae60',
    icon: '🎯',
  },
  {
    path: '/lead-upload',
    title: 'Lead Upload',
    description: 'Upload CSV lead files, track upload history, and review past submissions.',
    color: '#8e44ad',
    icon: '📤',
  },
  {
    path: '/targeting-lists',
    title: 'List Management',
    description: 'Create and manage targeting lists for lead verification. Assign lists to programs and goals.',
    color: '#1abc9c',
    icon: '🗂️',
  },
  {
    path: '/suppliers',
    title: 'Suppliers',
    description: 'Manage supplier accounts and their goal assignments.',
    color: '#2980b9',
    icon: '🏭',
  },
  {
    path: '/clients',
    title: 'Clients',
    description: 'Manage advertisers and agencies. Clients are the foundation of every program.',
    color: '#3498db',
    icon: '👥',
  },
  {
    path: '/reports/billable-by-supplier',
    title: 'Reports',
    description: 'Leads by supplier, lead quality analysis, and revenue recognition.',
    color: '#c0392b',
    icon: '📊',
  },
];

export default function Home() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    Promise.allSettled([
      axios.get(`${API}/programs/`),
      axios.get(`${API}/components/`),
      axios.get(`${API}/goals/`),
      axios.get(`${API}/leads/summary`),
    ]).then(([programs, components, goals, leadSummary]) => {
      const totalLeads = leadSummary.status === 'fulfilled'
        ? leadSummary.value.data.reduce((s, g) => s + (g.total || 0), 0)
        : 0;
      setStats({
        programs:   programs.status   === 'fulfilled' ? programs.value.data.length   : 0,
        components: components.status === 'fulfilled' ? components.value.data.length : 0,
        goals:      goals.status      === 'fulfilled' ? goals.value.data.length      : 0,
        leads:      totalLeads,
      });
    });
  }, []);

  const statFor = (title) => {
    if (!stats) return null;
    if (title === 'Programs')    return { main: stats.programs,   label: 'programs' };
    if (title === 'Components')  return { main: stats.components, label: 'components' };
    if (title === 'Goals')       return { main: stats.goals,      label: 'goals' };
    if (title === 'Lead Upload') return { main: stats.leads,      label: 'leads uploaded' };
    return null;
  };

  return (
    <div style={{ maxWidth: '960px', margin: '0 auto' }}>
      {/* Hero */}
      <div style={{ marginBottom: '40px' }}>
        <h1 style={{ margin: '0 0 8px', fontSize: '28px', color: '#2c3e50' }}>DemandArc</h1>
        <p style={{ margin: 0, color: '#7f8c8d', fontSize: '15px' }}>
          Manage programs, goals, and lead delivery from a single platform.
        </p>
      </div>

      {/* Cards grid */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: '20px' }}>
        {PAGES.map(page => {
          const stat = statFor(page.title);
          return (
            <Link
              key={page.path}
              to={page.path}
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              <div style={{
                background: 'white',
                borderRadius: '10px',
                border: '1px solid #e8ecef',
                overflow: 'hidden',
                boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
                transition: 'box-shadow 0.15s, transform 0.15s',
                cursor: 'pointer',
              }}
                onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.12)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
                onMouseLeave={e => { e.currentTarget.style.boxShadow = '0 1px 4px rgba(0,0,0,0.06)'; e.currentTarget.style.transform = 'translateY(0)'; }}
              >
                <div style={{ height: '5px', background: page.color }} />
                <div style={{ padding: '20px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                    <span style={{ fontSize: '22px' }}>{page.icon}</span>
                    <span style={{ fontSize: '17px', fontWeight: '600', color: '#2c3e50' }}>{page.title}</span>
                  </div>
                  <p style={{ margin: '0 0 16px', fontSize: '13px', color: '#7f8c8d', lineHeight: '1.5' }}>
                    {page.description}
                  </p>
                  {stat ? (
                    <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px' }}>
                      <span style={{ fontSize: '26px', fontWeight: '700', color: page.color }}>{stat.main.toLocaleString()}</span>
                      <span style={{ fontSize: '13px', color: '#95a5a6' }}>{stat.label}</span>
                    </div>
                  ) : (
                    <div style={{ height: '32px', background: '#f5f5f5', borderRadius: '4px', width: '60px' }} />
                  )}
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
